/**
 * demoData.js
 * -----------
 * Sample card data so the UI works without Supabase or any backend.
 * Used automatically when env vars are missing (which is the case
 * for the drag-and-drop preview deploy).
 */

export const IS_DEMO = !import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.VITE_SUPABASE_URL.includes('YOUR-PROJECT');

export const DEMO_CARD = {
  id: 'demo-card-001',
  serial_number: 'MC-DEMO01',
  full_name_en: 'Mohammed Al-Zahrani',
  full_name_ar: 'محمد الزهراني',
  title_en: 'Regional Sales Manager',
  title_ar: 'مدير المبيعات الإقليمي',
  company: 'Company',
  phone: '+966 54 202 8456',
  email: 'mohammed@company.com',
  linkedin_url: 'https://linkedin.com/in/mohammed-z',
  x_url: '@mohammed_z',
  website: 'https://engmohammed.net',
  office_location: 'Jeddah, Saudi Arabia',
  about_en: 'B2B enterprise sales lead. Building Arabic-first digital products and SaaS tools.',
  about_ar: 'قائد مبيعات المؤسسات. أبني منتجات رقمية عربية وأدوات SaaS.',
  bg_color: '#FFFFFF',
  fg_color: '#0A0A0A',
  label_color: '#6E6E6E',
  logo_path: null,
  photo_path: null
};

export const DEMO_USER = {
  id: 'demo-user-001',
  email: 'demo@cardpass.app'
};

// Assets for the landing "live demo" Showcase (the "your card forms in front of
// you" section). Drop the real files in public/demo/ with these exact names and
// they appear automatically on the demo pass — the Aramco wordmark as the logo
// and a sample headshot as the photo.
export const DEMO_LOGO_URL = '/demo/aramco-logo.png';
export const DEMO_PHOTO_URL = '/demo/profile.jpg';
